import { render, staticRenderFns } from "./KernelChart.vue?vue&type=template&id=56c01e7f&"
import script from "./KernelChart.vue?vue&type=script&lang=js&"
export * from "./KernelChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports